import { render, staticRenderFns } from "./adminAdditionalClientOrder.vue?vue&type=template&id=0544bf84&scoped=true&"
import script from "./adminAdditionalClientOrder.vue?vue&type=script&lang=js&"
export * from "./adminAdditionalClientOrder.vue?vue&type=script&lang=js&"
import style0 from "./adminAdditionalClientOrder.vue?vue&type=style&index=0&id=0544bf84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0544bf84",
  null
  
)

export default component.exports